<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" text="Chi tiết hồ sơ" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="detailsFile"/>
            </vx-tooltip>
        </div>

        <vs-popup title="Chi tiết hồ sơ" :active.sync="popupShowDetailsFileExam" v-if="popupShowDetailsFileExam"
                  id="details_file_exam">
            <div class="vx-card" style="min-height: 170px">
                <div class="vx-row">
                    <div class="vx-col w-1/4 py-6 pl-8 info_file">
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full mb-2">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Khách hàng:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                    <span
                                        class="text-md font-semibold">{{ infoFileData.loyaltyCustomer.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Trạng thái (KH):</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <vs-chip class="ag-grid-cell-chip"
                                                 :color="chipColorType(infoFileData.customerType)">
                                        <span
                                            class="text-md font-semibold">{{
                                                checkStatusType(infoFileData.customerType)
                                            }}</span>
                                        </vs-chip>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.dateAdmissionStr">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Ngày vào viện:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.dateAdmissionStr }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.diagnostic">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Chẩn đoán:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.diagnostic }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.conclude">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Kết luận:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.conclude }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.consultant">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Tư vấn:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.consultant.fullName }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-2" v-if="infoFileData.doctor">
                                <div class="vx-row">
                                    <div class="vx-col lg:w-1/3 w-full">
                                        <span class="text-md font-semibold">Bác sĩ:</span>
                                    </div>
                                    <div class="vx-col lg:w-2/3 w-full">
                                        <span class="text-md">{{ infoFileData.doctor.fullName }}</span>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="vx-col w-full mb-2" v-if="infoFileData.note">-->
<!--                                <div class="vx-row">-->
<!--                                    <div class="vx-col lg:w-1/3 w-full">-->
<!--                                        <span class="text-md font-semibold">Ghi chú:</span>-->
<!--                                    </div>-->
<!--                                    <div class="vx-col lg:w-2/3 w-full">-->
<!--                                        <span class="text-md">{{ infoFileData.note }}</span>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="vx-col w-3/4 py-6 pl-8">
<!--                        <div class="vx-row">-->
<!--                            <div class="vx-col w-full">-->
<!--                                <vs-input icon-no-border icon="icon-search" icon-pack="feather"-->
<!--                                          class="w-full input-rounded-full pr-8"-->
<!--                                          placeholder="Tìm phiếu theo mã phiếu ..." v-model="keySearch"-->
<!--                                          @input="searchMedical"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <VuePerfectScrollbar ref="scrollDialog"-->
<!--                                             class="scroll-area&#45;&#45;nofications-dropdown size-content vx-row mt-6 match-height"-->
<!--                                             :settings="settings"-->
<!--                                             style="max-height: 70vh">-->
<!--                            <div class="vx-col xl:w-1/3 md:w-1/2 w-full mb-6"-->
<!--                                 v-for="(item, index) in detailsMedicalDataSearch"-->
<!--                                 :key="index">-->
<!--                                <div class="medical-bill w-full" @click="showDetailsFile(item)">-->
<!--                                    <div class="vx-row m-4">-->
<!--                                        <div class="vx-col w-full">-->
<!--                                            <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px"-->
<!--                                                 viewBox="0 0 24 24" fill="none">-->
<!--                                                <path fill-rule="evenodd" clip-rule="evenodd"-->
<!--                                                      d="M12 11.75C12.4142 11.75 12.75 12.0858 12.75 12.5V13.25H13.5C13.9142 13.25 14.25 13.5858 14.25 14C14.25 14.4142 13.9142 14.75 13.5 14.75H12.75V15.5C12.75 15.9142 12.4142 16.25 12 16.25C11.5858 16.25 11.25 15.9142 11.25 15.5V14.75H10.5C10.0858 14.75 9.75 14.4142 9.75 14C9.75 13.5858 10.0858 13.25 10.5 13.25H11.25V12.5C11.25 12.0858 11.5858 11.75 12 11.75Z"-->
<!--                                                      fill="#1C274C"/>-->
<!--                                                <path fill-rule="evenodd" clip-rule="evenodd"-->
<!--                                                      d="M11.948 1.25C11.0495 1.24997 10.3003 1.24995 9.70552 1.32991C9.07773 1.41432 8.51093 1.59999 8.05546 2.05546C7.59999 2.51093 7.41432 3.07773 7.32991 3.70552C7.24995 4.3003 7.24997 5.04952 7.25 5.948L7.25 6.02572C5.22882 6.09185 4.01511 6.32803 3.17157 7.17158C2 8.34315 2 10.2288 2 14C2 17.7712 2 19.6569 3.17157 20.8284C4.34314 22 6.22876 22 9.99998 22H14C17.7712 22 19.6569 22 20.8284 20.8284C22 19.6569 22 17.7712 22 14C22 10.2288 22 8.34315 20.8284 7.17158C19.9849 6.32803 18.7712 6.09185 16.75 6.02572L16.75 5.94801C16.75 5.04954 16.7501 4.3003 16.6701 3.70552C16.5857 3.07773 16.4 2.51093 15.9445 2.05546C15.4891 1.59999 14.9223 1.41432 14.2945 1.32991C13.6997 1.24995 12.9505 1.24997 12.052 1.25H11.948ZM15.25 6.00189V6C15.25 5.03599 15.2484 4.38843 15.1835 3.9054C15.1214 3.44393 15.0142 3.24644 14.8839 3.11612C14.7536 2.9858 14.5561 2.87858 14.0946 2.81654C13.6116 2.7516 12.964 2.75 12 2.75C11.036 2.75 10.3884 2.7516 9.90539 2.81654C9.44393 2.87858 9.24643 2.9858 9.11612 3.11612C8.9858 3.24644 8.87858 3.44393 8.81654 3.9054C8.75159 4.38843 8.75 5.03599 8.75 6V6.00189C9.14203 6 9.55807 6 10 6H14C14.4419 6 14.858 6 15.25 6.00189ZM16 14C16 16.2091 14.2091 18 12 18C9.79086 18 8 16.2091 8 14C8 11.7909 9.79086 10 12 10C14.2091 10 16 11.7909 16 14Z"-->
<!--                                                      fill="#1C274C"/>-->
<!--                                            </svg>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2 flex flex-wrap justify-center">-->
<!--                                            <span>Mã phiếu: </span>-->
<!--                                            <span class="text-md font-semibold">{{-->
<!--                                                    item.beautySubclinicalNanoCode-->
<!--                                                }}</span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2 flex flex-wrap justify-center">-->
<!--                                            <span>Thời gian thực hiện: </span>-->
<!--                                            <span class="text-md font-semibold">{{-->
<!--                                                    item.hospitalAdmissionDateStr-->
<!--                                                }}</span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full mb-2 flex flex-wrap justify-center"-->
<!--                                             v-if="item.beautyService">-->
<!--                                            <span>Dịch vụ: </span>-->
<!--                                            <span class="text-md font-semibold">{{-->
<!--                                                    item.beautyService.code + '-' + item.beautyService.name-->
<!--                                                }}</span>-->
<!--                                        </div>-->
<!--                                        <div class="vx-col w-full flex flex-wrap justify-center items-center gap-4">-->
<!--                                            <span class="text-md font-semibold">Trạng thái:</span>-->
<!--                                            <vs-chip class="ag-grid-cell-chip"-->
<!--                                                     :color="item.settingMedicalExaminationStep.medicalExaminationStep.color">-->
<!--                                            <span class="text-md font-semibold">-->
<!--                                                {{ item.settingMedicalExaminationStep.medicalExaminationStep.name }}-->
<!--                                            </span>-->
<!--                                            </vs-chip>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </VuePerfectScrollbar>-->
<!--                        <div class="vx-row" v-if="detailsMedicalDataSearch.length === 0">-->
<!--                            <div class="vx-col w-full text-center">-->
<!--                                <span>Không có dữ liệu</span>-->
<!--                            </div>-->
<!--                        </div>-->
                        <vs-tabs v-model="activeTabExam">
                            <vs-tab label="Phẫu thuật, thủ thuật">
                                <ParaclinicalExaminationStep :type="activeTabExam" :beautyMedicalRecordId="infoFileData.id" :statusOptions="statusOptions"></ParaclinicalExaminationStep>
                            </vs-tab>
                            <vs-tab label="Chẩn đoán hình ảnh">
                                <ParaclinicalExaminationStep :type="activeTabExam" :beautyMedicalRecordId="infoFileData.id" :statusOptions="statusOptions"></ParaclinicalExaminationStep>
                            </vs-tab>
                            <vs-tab label="Thăm dò chức năng">
                                <ParaclinicalExaminationStep :type="activeTabExam" :beautyMedicalRecordId="infoFileData.id" :statusOptions="statusOptions"></ParaclinicalExaminationStep>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </div>
            </div>

            <vs-popup class="holamundo" id="details_file_exam_popup"
                      :active.sync="isShowDetailsFile">
                <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                        <h4>Chi tiết phiếu</h4>
                        <feather-icon icon="XIcon" class="hover:text-danger" svgClasses="h-5 w-5"
                                      @click="closeDetailsFile"/>
                    </div>
                </div>
                <vs-divider/>
                <div class="vx-row mt-6" v-if="examinationtInfo && examinationtInfo.beautySubclinicalNanoCode">
                    <div class="vx-col w-1/3">
                        <span class="text-md font-semibold">Mã phiếu:</span>
                    </div>
                    <div class="vx-col w-2/3">
                    <span class="text-md font-semibold text-primary">{{
                            examinationtInfo.beautySubclinicalNanoCode
                        }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="examinationtInfo && examinationtInfo.hospitalAdmissionDateStr">
                    <div class="vx-col w-1/3">
                        <span class="text-md font-semibold">Thời gian thực hiện:</span>
                    </div>
                    <div class="vx-col w-2/3">
                        <span class="text-md">{{ examinationtInfo.hospitalAdmissionDateStr }}</span>
                    </div>
                </div>
                <div class="vx-row mt-4" v-if="examinationtInfo && examinationtInfo.beautyService">
                    <div class="vx-col w-1/3">
                        <span class="text-md font-semibold">Nhóm dịch vụ:</span>
                    </div>
                    <div class="vx-col w-2/3">
                    <span class="text-md font-semibold text-primary">
                        {{ examinationtInfo.beautyService.code + ' - ' + examinationtInfo.beautyService.name }}
                    </span>
                    </div>
                </div>
                <div class="vx-row mt-6" v-if="examinationtInfo">
                    <div class="vx-col w-1/3">
                        <span class="text-md font-semibold">Trạng thái:</span>
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-chip class="ag-grid-cell-chip"
                                 :color="examinationtInfo.settingMedicalExaminationStep.medicalExaminationStep.color">
                        <span
                            class="text-md font-semibold">{{
                                examinationtInfo.settingMedicalExaminationStep.medicalExaminationStep.name
                            }}
                        </span>
                        </vs-chip>
                    </div>
                </div>
                <div class="vx-row mt-6"
                     v-if="examinationtInfo && examinationtInfo.beautySubclinicalDetails.length > 0">
                    <div class="vx-col w-full md:flex" v-for="(item, ind) in examinationtInfo.beautySubclinicalDetails"
                         :key="ind">
                        <div class="md:flex justify-center items-center icon-subclinical-details mr-2 hidden">
                            <feather-icon icon="PackageIcon" class="text-primary" svgClasses="h-8 w-8"/>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full flex justify-between">
                            <span class="text-md font-semibold text-primary">
                                {{
                                    item.beautyServicePackage ? (item.beautyServicePackage.code + ' - ' + item.beautyServicePackage.name) : item.beautyPackageCombo ? (item.beautyPackageCombo.code + ' - ' + item.beautyPackageCombo.name) : null
                                }}
                            </span>
                                <span class="text-md font-semibold text-primary">{{
                                        numberWithCommas(item.unitPrice) + ' VND'
                                    }}</span>
                            </div>
                            <div class="vx-col w-full flex justify-between">
                                <vs-chip class="ag-grid-cell-chip" :color="item.allIn ? 'warning' : 'primary'">
                                    <span class="text-md font-semibold">{{ item.allIn ? 'Combo' : 'Dịch vụ lẻ' }}</span>
                                </vs-chip>
                                <vs-chip class="ag-grid-cell-chip" :color="item.paid === 0 ? 'danger' : 'success'">
                                    <span class="text-md font-semibold">{{
                                            item.paid === 0 ? 'Chưa thanh toán' : 'Đã thanh toán'
                                        }}</span>
                                </vs-chip>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-popup>
        </vs-popup>
    </div>
</template>

<script>
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
// import vSelect from 'vue-select';
// import Datepicker from 'vuejs-datepicker';
// import {en, vi} from 'vuejs-datepicker/dist/locale'
// import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import ParaclinicalExaminationStep from "../../customer/cell-renderer/medical-step/ParaclinicalExaminationStep"

export default {
    name: "CellRendererActionsExam",
    components: {
        // flatPickr,
        // vSelect,
        // Datepicker
        VuePerfectScrollbar,
        ParaclinicalExaminationStep,
    },
    props: {
    rowData: {
      type: Object,
      required: true,
    },},
    data() {
        return {
            popupCreateFile: false,
            createdDate: new Date(),
            configDatePicker: {
                dateFormat: 'd-m-Y',
            },
            customerTypeOptions: [
                {value: 1, label: "Khách hàng cũ tới tái khám"},
                {value: 2, label: "Khách hàng cũ sử dụng dịch vụ"},
                {value: 3, label: "Khách hàng cũ tới tư vấn dv"},
                {value: 4, label: "Khách hàng mới đến tư vấn"},
                {value: 5, label: "Khách hàng tới mua thuốc mỹ phẩm"},
                {value: 6, label: "Khách hàng trả lại thuốc"},
                {value: 7, label: "Khách hàng tới hoàn phí"},
            ],
            selectedCustomerTypeValue: null,
            beautyBooking: null,
            healthInsuranceNum: null,
            reasonForExamination: null,
            noteReason: null,
            stepOptions: [
                {value: 1, label: 'Tiếp đón'},
                {value: 2, label: 'Tư vấn'},
                {value: 3, label: 'Thu phí'},
                {value: 4, label: 'Cận lâm sàng'},
                {value: 5, label: 'Hoàn thành'},
            ],
            selectedStepValue: null,
            employeeOptions: [],
            selectedEmployeeValue1: null,
            selectedEmployeeValue2: null,
            selectedDoctorValue: null,
            boarding: false,

            popupShowDetailsFileExam: false,
            keySearch: null,
            settings: {
                wheelSpeed: 0.3,
                suppressScrollX: true,
            },
            isShowDetailsFile: false,
            infoFileData: [],
            detailsMedicalData: [],
            detailsMedicalDataSearch: [],
            examinationtInfo: null,
            activeTabExam: 0,
            statusOptions: [],
        }
    },

    computed: {
        chipColorType() {
            return value => {
                if (value === 1) {
                    return "primary";
                } else if (value === 2) {
                    return 'warning'
                } else if (value === 3) {
                    return 'success'
                } else if (value === 4) {
                    return 'danger'
                } else if (value === 5) {
                    return 'primary'
                }
            }
        },
        checkStatusType() {
            return value => {
                if (value === 1) {
                    return "Thu phí dịch vụ";
                } else if (value === 2) {
                    return "Thu phí combo"
                } else if (value === 3) {
                    return "Thu phí thuốc"
                } else if (value === 4) {
                    return "Công nợ"
                } else if (value === 5) {
                    return "Tạm ứng"
                }
            }
        },
        chipColorStatus() {
            return value => {
                if (value === 0) {
                    return "danger";
                } else if (value === 1) {
                    return 'success'
                }
            }
        },
        checkStatus() {
            return value => {
                if (value === 0) {
                    return "Chưa thanh toán";
                } else if (value === 1) {
                    return "Đã thanh toán"
                }
            }
        },
    },

    methods: {
        async detailsFile() {
            this.infoFileData = this.rowData;
            this.infoFileData.dateAdmissionStr = this.infoFileData.dateAdmission ? moment(this.infoFileData.dateAdmission).format('DD/MM/YYYY') : null;
            this.detailsMedicalData = this.infoFileData.beautySubclinicals.map(el => {
                el.hospitalAdmissionDateStr = moment(el.hospitalAdmissionDate).format('DD/MM/YYYY HH:mm:ss');
                return el;
            });
            await this.getParentId();
            // this.detailsMedicalDataSearch = this.detailsMedicalData;
            this.popupShowDetailsFileExam = true;
            // this.$router.push(`/user/details-file-in-examination?idFile=${this.params.data.id}`).catch(() => {
            // });
        },

        getParentId() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/setting-medical-examination-step/find-by-condition', {isGetParent: true}).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.statusOptions = res.data.content[3].listChildren.map(el => {
                            return {
                                value: el.id,
                                label: el.medicalExaminationStep.name,
                            }
                        })
                        this.statusOptions.unshift({value: 'null', label: 'Tất cả'})
                    }
                    this.$vs.loading.close();
                    resolve(res)
                }).catch(err => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        // showDetailsFile(data) {
        //     this.examinationtInfo = null;
        //     this.examinationtInfo = data;
        //     setTimeout(() => {
        //         this.isShowDetailsFile = true
        //     }, 100)
        // },

        closeDetailsFile() {
            this.isShowDetailsFile = false;
        },

        // searchMedical(event) {
        //     let str = event.toLowerCase();
        //     this.detailsMedicalDataSearch = this.detailsMedicalData.filter(el => el.beautySubclinicalNanoCode.toLowerCase().includes(str))
        // },
        //
        // numberWithCommas(x) {
        //     x = x.toString();
        //     let pattern = /(-?\d+)(\d{3})/;
        //     while (pattern.test(x))
        //         x = x.replace(pattern, "$1,$2");
        //     return x;
        // },
    }
}
</script>

<style lang="scss">
#details_file_exam {
    min-height: 170px;

    .medical-bill {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        border: 1px solid #dbdade;
        border-radius: 0.375rem;
        min-height: 150px;
        cursor: pointer;
    }

    .medical-bill:hover {
        color: rgba(var(--vs-primary), 1);
        border: 1px solid rgba(var(--vs-primary), 1);

        svg path {
            fill: rgba(var(--vs-primary), 1);
        }
    }

    .info_file {
        border-right: 1px solid #dbdade;
        //display: flex;
        //justify-content: center;
    }

    .vs-popup {
        width: 100% !important;
    }
}

#details_file_exam_popup {
    .vs-popup--header {
        display: none;
    }

    .icon-subclinical-details {
        background-color: rgba(var(--vs-primary), .15);
        width: 50px;
        border-radius: 0.375rem;
    }
}
</style>
